/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';

function calcPadding({
  isReady,
  placeholderAspectRatio
}) {
  return isReady ? '0' : (100 / placeholderAspectRatio).toFixed(2).toString();
}

const Padding = styled.div.withConfig({
  displayName: "Wrapper__Padding",
  componentId: "sc-15cwajm-0"
})(["position:relative;padding-top:", "%;background-color:", ";"], calcPadding, props => props.loadingBackground || '');
const Container = styled.div.withConfig({
  displayName: "Wrapper__Container",
  componentId: "sc-15cwajm-1"
})(["position:", ";top:0;height:100%;width:100%;"], props => props.isReady ? 'relative' : 'absolute');
export default (props => {
  return /*#__PURE__*/_jsx(Padding, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(Container, {
      isReady: props.isReady,
      children: props.children
    })
  }));
});